"use strict";
import {createSwiper} from "./swiper";
import {onFind} from "@elements/init-modules-in-scope";
import {findIn} from '@elements/dom-utils';

export function init () {

    onFind('.js-img-slider', function (sliderElement) {


        createSwiper(sliderElement, {
                loop: true,
                slidesPerView: 1,
                navigation: {
                    findNextElement: swiperContainer => findIn('.js-img-slider__next', swiperContainer),
                    findPrevElement: swiperContainer => findIn('.js-img-slider__prev', swiperContainer),
                },
                pagination: {
                    el: swiperContainer => findIn('.js-img-slider__pagination', swiperContainer),
                    clickable: true
                }
            },
            {
                sliderContainer: '.js-img-slider',
                slider: '.js-img-slider__slider'
            });

    });
}

